import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import ym from 'react-yandex-metrika'
import './style.css'

const Contacts = ({ t }) => {

    useEffect(() => {
        ym('hit', '/contacts')
    }, [])

    return (
        <main className="app__content--contacts">
            <Helmet>
                <title>{ t('Contacts') }</title>
            </Helmet>
            <div className="app__content--body">
                <div className="app__content--legal-info">
                    <h1>Юридическая информация</h1>
                    <p>
                        Общество с ограниченной ответственностью <strong>&#171;Клокворк&#187;</strong><br/>
                        ИНН: <strong>2465141520</strong><br/>
                        КПП: <strong>246501001</strong><br/>
                        ОГРН: <strong>1162468061634</strong><br/>
                        Юр. Адрес: <strong>660125, Красноярский кр., г. Красноярск, проспект Комсомольский, д. 22 к. 1 кв. 82</strong><br/>
                        Р/c: <strong>4070 2810 5062 7000 0883</strong><br/>
                        Банк: <strong>ООО "Банк Точка"</strong><br/>
                        БИК: <strong>044 525 104</strong><br/>
                        Корр/с: <strong>3010 1810 7453 7452 5104</strong><br/>
                        Email: <strong>hello@clockwork.one</strong><br/>
                        Тел.: <strong>+7 (913) 570-32-22</strong><br/>
                        Веб-сайт: <strong>clockwork.one</strong>
                    </p>
                </div>
                <div className="app__content--contacts-footer">
                    <p className="app__content--text">
                        {t('contacts.city')},<br/>{t('contacts.street')}
                    </p>
                    <div className="app__content--info">
                        <a
                            href="mailto:hello@clockwork.one"
                            className="app__content--text">
                            hello@clockwork.one
                        </a>
                        <a
                            href="tel:+79135703222"
                            className="app__content--text">
                            +7 (913) 570-32-22
                        </a>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default translate('translations')(Contacts)



// WEBPACK FOOTER //
// ./src/Pages/Contacts/index.js